/**
 * Service Types for Sliding Text Component
 * Defines the structure and data for service items displayed in the sliding text marquee
 */

// Import service images
import alignmentImage from '../../assets/logo/services/alignment.webp';
import diagnosticTestImage from '../../assets/logo/services/diagnostic_test.webp';
import roadyReviewImage from '../../assets/logo/services/roady_review.webp';
import shockAbsorbersImage from '../../assets/logo/services/shock_absorbers.webp';
import inspectionImage from '../../assets/logo/services/inspection.webp';
import generalMechanicsImage from '../../assets/logo/services/general_mechanics.webp';
import servicePackImage from '../../assets/logo/services/service_pack.webp';
import airConditioningImage from '../../assets/logo/services/air_conditioning.webp';
import headlightRestorationImage from '../../assets/logo/services/headlight_restoration.webp';
import batteriesImage from '../../assets/logo/services/batteries.webp';
import brakesImage from '../../assets/logo/services/brakes.webp';

export type ServiceTranslationKey = 
    | 'autoRepair' 
    | 'brakeInspection' 
    | 'engineDiagnostics' 
    | 'tireReplacement' 
    | 'oilChange' 
    | 'batteryService' 
    | 'alignment' 
    | 'diagnosticTest' 
    | 'roadyReview' 
    | 'shockAbsorbers' 
    | 'inspection' 
    | 'generalMechanics';

export interface ServiceItem {
    iconClass: string;
    translationKey: ServiceTranslationKey;
}

export const SLIDING_TEXT_SERVICE_ITEMS: ServiceItem[] = [
    { iconClass: 'icon-mechanical', translationKey: 'autoRepair' },
    { iconClass: 'icon-tire', translationKey: 'brakeInspection' },
    { iconClass: 'icon-diagnostic', translationKey: 'engineDiagnostics' },
    { iconClass: 'icon-tyre', translationKey: 'tireReplacement' },
    { iconClass: 'icon-oil', translationKey: 'oilChange' },
    { iconClass: 'icon-battery', translationKey: 'batteryService' },
    { iconClass: 'icon-mechanical', translationKey: 'alignment' },
    { iconClass: 'icon-diagnostic', translationKey: 'diagnosticTest' },
    { iconClass: 'icon-mechanical', translationKey: 'roadyReview' },
    { iconClass: 'icon-tire', translationKey: 'shockAbsorbers' },
    { iconClass: 'icon-diagnostic', translationKey: 'inspection' },
    { iconClass: 'icon-mechanical', translationKey: 'generalMechanics' }
];

/**
 * Service Types for Services Section Component
 * Defines the structure and data for service cards displayed in the services carousel
 */

export interface Service {
    id: number;
    route: string;
    iconClass: string;
    imageSrc: string;
    imageAlt: string;
    titleKey: string;
    descKey: string;
    budgetParam: string;
}

export const SERVICES_DATA: Service[] = [
    {
        id: 1,
        route: '/oficina/alinhamento',
        budgetParam: 'alinhamento',
        iconClass: 'icon-tire',
        imageSrc: alignmentImage,
        imageAlt: 'Alignment Service',
        titleKey: 'alignment',
        descKey: 'alignmentDesc'
    },
    {
        id: 2,
        route: '/oficina/teste-diagnostico',
        budgetParam: 'diagnostico',
        iconClass: 'icon-car',
        imageSrc: diagnosticTestImage,
        imageAlt: 'Diagnostic Test Service',
        titleKey: 'diagnosticTest',
        descKey: 'diagnosticTestDesc'
    },
    {
        id: 3,
        route: '/oficina/revisoes-roady',
        budgetParam: 'revisao',
        iconClass: 'icon-mechanical',
        imageSrc: roadyReviewImage,
        imageAlt: 'Roady Malveira Revisions Service',
        titleKey: 'roadyReview',
        descKey: 'roadyReviewDesc'
    },
    {
        id: 4,
        route: '/oficina/amortecedores',
        budgetParam: 'amortecedores',
        iconClass: 'icon-tyre',
        imageSrc: shockAbsorbersImage,
        imageAlt: 'Shock Absorbers Service',
        titleKey: 'shockAbsorbers',
        descKey: 'shockAbsorbersDesc'
    },
    {
        id: 5,
        route: '/oficina/inspecao',
        budgetParam: 'inspecao',
        iconClass: 'icon-car-wash',
        imageSrc: inspectionImage,
        imageAlt: 'Inspection Service',
        titleKey: 'inspection',
        descKey: 'inspectionDesc'
    },
    {
        id: 6,
        route: '/oficina/mecanica-geral',
        budgetParam: 'mecanica',
        iconClass: 'icon-mechanical',
        imageSrc: generalMechanicsImage,
        imageAlt: 'General Mechanics Service',
        titleKey: 'generalMechanics',
        descKey: 'generalMechanicsDesc'
    },
    {
        id: 7,
        route: '/oficina/servicos-oficina',
        budgetParam: 'pacote',
        iconClass: 'icon-oil',
        imageSrc: servicePackImage,
        imageAlt: 'Workshop Services Pack',
        titleKey: 'workshopServices',
        descKey: 'workshopServicesDesc'
    },
    {
        id: 8,
        route: '/oficina/ar-condicionado',
        budgetParam: 'ar-condicionado',
        iconClass: 'icon-fan',
        imageSrc: airConditioningImage,
        imageAlt: 'Air Conditioning Service',
        titleKey: 'airConditioning',
        descKey: 'airConditioningDesc'
    },
    {
        id: 10,
        route: '/oficina/restauro-farois',
        budgetParam: 'farois',
        iconClass: 'icon-low-beam',
        imageSrc: headlightRestorationImage,
        imageAlt: 'Headlight Restoration Service',
        titleKey: 'headlightRestoration',
        descKey: 'headlightRestorationDesc'
    },
    {
        id: 11,
        route: '/oficina/baterias',
        budgetParam: 'baterias',
        iconClass: 'icon-battery',
        imageSrc: batteriesImage,
        imageAlt: 'Batteries Service',
        titleKey: 'batteries',
        descKey: 'batteriesDesc'
    },
    {
        id: 12,
        route: '/oficina/travoes',
        budgetParam: 'travoes',
        iconClass: 'icon-brake',
        imageSrc: brakesImage,
        imageAlt: 'Brakes Service',
        titleKey: 'brakes',
        descKey: 'brakesDesc'
    }
];

